module.exports = __webpack_public_path__ + "static/expectations-e4aafefa4175b06116d9e84673b62061.pdf";